import React from "react";
import Table from "../common/Table";

const cellStyling = {
    textAlign: "left",
    borderRight: "1px solid #eee",
    padding: "8px",
};

const headerStyling = {
    textAlign: "center",
    fontFamily: "system-ui",
    backgroundColor: "#b9b9b9",
    padding: "10px",
    borderRight: "1px solid #eee",
    whiteSpace: "normal",
    lineHeight: "normal",
    height: "auto !important"
};

const ServiceHistoryTable = ({
    className = "",
    sx: customSx = {},
    ...restProps
}) => {
    const sx = {
        ...customSx,
        "& .MuiDataGrid-cell": {
            ...cellStyling,
            ...customSx["& .MuiDataGrid-cell"],
        },
        "& .MuiDataGrid-columnHeader": {
            ...headerStyling,
            ...customSx["& .MuiDataGrid-columnHeader"],
        },
        "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "normal",
            fontWeight: 'bold',
            ...customSx["& .MuiDataGrid-columnHeaderTitle"],
        }
    };

    return (
        <Table
            sx={sx}
            rowHeight={90}
            headerHeight={100}
            className={className}
            {...restProps}
            disableRowSelectionOnClick
        />
    );
};

export default ServiceHistoryTable;